import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Lock.es.js";
const c = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: a }));
c.displayName = "LockIcon";
const n = c;
export {
  n as Lock,
  c as LockIcon
};
